import i18n from '../../../../../../../../../../i18n';
import { buildPanelGridCommonData } from '../buildPanelGridCommonData/buildPanelGridCommonData';

export const buildPanelGridDemoData = (
  sessionInfo: SessionInformation,
): PanelGridDataItem[] => {
  const { parentDemo } = sessionInfo;

  return [
    {
      key: 'parentDemo',
      name: i18n.t('sessions.panels.info.sessionInformation.parentDemo'),
      value: parentDemo,
    },
    ...buildPanelGridCommonData(sessionInfo),
  ];
};
